<template>
  <v-text-field
    v-model="fieldValue"
    :label="labelValue"
    validate-on-blur
    :rules="[required(labelValue), match(passwordToMatch, 'Password')]"
    :type="fieldType"
    outlined
    :append-icon="icon"
    @click:append="appendedIconClick"
  ></v-text-field>
</template>

<script>
import { required, match } from '@/lib/formValidations'
export default {
  props: [
    'label',
    'passwordToMatch',
    'value'
  ],
  data () {
    return {
      fieldType: 'password',
      icon: 'visibility'
    }
  },
  computed: {
    fieldValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('valueChange', newValue)
      }
    },
    labelValue () {
      return this.label ? this.label : 'Confirmation New Password'
    }
  },
  methods: {
    required,
    match,
    appendedIconClick () {
      this.fieldType = this.fieldType === 'password' ? null : 'password'
      this.icon = this.icon === 'visibility' ? 'visibility_off' : 'visibility'
    },
    reset () {
      this.fieldType = 'password'
      this.icon = 'visibility'
    }
  },
  mounted () {
    this.reset()
  }
}
</script>
